import React from 'react'
import AboutUsHero from '../components/about/AboutUsHero'
import AboutStatsSection from '../components/about/AboutStatsSection'
import WhyWeAreDifferentSection from '../components/about/WhyWeAreDifferentSection'
import OurPromiseSection from '../components/about/OurPromiseSection'
import AboutCtaSection from '../components/about/AboutCtaSection'
import FaqSection from '../components/home/FaqSection'
import SEO from '../components/seo/SEO'

export default function AboutUs() {
  return (
    <>
      <SEO
        title="About Us | Logo Branded Door Mats Zambia"
        description="Learn about Logo Branded Door Mats Zambia - your trusted partner for premium custom branded door mats. We provide fast, reliable, and high-quality matting solutions across Zambia with precision engineering and local focus."
        keywords="about logo branded door mats, door mat company Zambia, custom mat manufacturer, branded mats supplier Zambia, door mat business, matting solutions provider"
        url="https://www.logobrandeddoormats.co.zm/about"
        image="https://www.logobrandeddoormats.co.zm/images/sectionimages/abouthero.png"
      />
      <AboutUsHero />
      <AboutStatsSection />
      <WhyWeAreDifferentSection />
      <OurPromiseSection />
      <AboutCtaSection />
      <FaqSection />
    </>
  )
}
